(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/helpers/handlebars-helper.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/helpers/handlebars-helper.js'); 'use strict';

registerHelpers(Handlebars);

function registerHelpers(hbs) {
  hbs.registerHelper('formatCurrency', function (number) {
    return svs.utils.format.Currency(number, false);
  });
  hbs.registerHelper('gameDate', function (dateString) {
    var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    dateString = dateString || svs.sport.result_boxes.models.myBetWager.get('draw').get('draw').regCloseTime;
    var inDate = moment(dateString).startOf('day'),
        today = moment().startOf('day'),
        gameDate = moment(dateString);

    if (inDate.isValid()) {
      var formattedDate;

      switch (inDate.diff(today, 'days')) {
        case -1:
          formattedDate = 'igår';
          break;

        case 0:
          formattedDate = 'idag';
          break;

        case 1:
          formattedDate = 'imorgon';
          break;

        default:
          formattedDate = gameDate.format('D/M');
          break;
      }

      return includeTime ? "".concat(formattedDate, " ").concat(gameDate.format('HH:mm')) : formattedDate;
    }

    return '';
  });
  hbs.registerHelper('doubleWinAmount', function (drawNumber, product, options) {
    return product === 'Stryktipset' && (drawNumber === 4580 || drawNumber === 4581) ? options.fn(this) : options.inverse(this);
  });
}
 })(window);